// Complete CV data for Wendpatekde Abimael RAMDE
export const profileData = {
  name: "Wendpatekde Abimael",
  lastName: "RAMDE",
  title: {
    fr: "Intervenant en Santé Mentale · Coach en parentalité",
    en: "Mental Health Practitioner · Parenting Coach"
  },
  email: "abimaelramde@gmail.com",
  birthDate: "12 Mai 1996",
  location: {
    fr: "Québec, Canada",
    en: "Quebec, Canada"
  },
  photo: "https://customer-assets.emergentagent.com/job_7c135517-6435-4fc5-86cb-e2ae2980f198/artifacts/0zhlllsk_IMG_1593.jpeg",
  badges: ["MyHPass", "APA Member", "ACSM Member"]
};

// Complete experiences from CV - Bilingual
export const experiencesData = {
  fr: [
    {
      id: 1,
      period: "Depuis 2023",
      title: "Fondateur",
      company: "Dobo Mind and General Service",
      location: "Burkina Faso",
      tagline: "Entreprise spécialisée dans le développement des organisations via la santé mentale.",
      tasks: [
        "Fondation et direction d'une entreprise inscrite au registre de commerce du Burkina Faso",
        "Développement des entreprises en utilisant la santé mentale comme levier stratégique",
        "Conseil et accompagnement des organisations sur le bien-être au travail",
        "Conception de programmes de santé mentale adaptés aux contextes professionnels"
      ]
    },
    {
      id: 2,
      period: "Depuis Septembre 2025",
      title: "Coach en parentalité et Santé Mentale",
      company: "MissPoppins",
      location: "États-Unis, Canada",
      tagline: "Coaching en parentalité, développement personnel et leadership auprès de familles et de cadres.",
      tasks: [
        "Accompagnement des parents sur la gestion du stress, des émotions et des dynamiques familiales",
        "Développement du leadership et aide à la prise de décision pour cadres et managers",
        "Promotion du bien-être mental et de la santé psychologique au quotidien"
      ]
    },
    {
      id: 3,
      period: "Août 2024 - Août 2025",
      title: "Consultant aux opérations",
      company: "Sephora Canada",
      location: "Québec, Canada",
      tagline: "Optimisation des processus opérationnels et accompagnement des équipes en magasin.",
      tasks: [
        "Analyse et amélioration des processus (stocks, flux, planification des ressources)",
        "Suivi des KPI et proposition d'actions correctives",
        "Soutien aux managers dans la mise en place des politiques internes",
        "Formation et accompagnement des équipes dans l'application des procédures"
      ]
    },
    {
      id: 4,
      period: "Septembre 2023 - Juin 2024",
      title: "Officier Santé Mentale - Équipe Évaluation RRM",
      company: "International Rescue Committee (IRC)",
      location: "Ouahigouya, Burkina Faso",
      tagline: "Appui psychosocial et évaluation des besoins en contexte de conflit.",
      tasks: [
        "Relever les alertes sur les chocs affectant les populations",
        "Développer et maintenir des relations avec les acteurs terrain",
        "Analyser les données collectées et émettre des recommandations",
        "Créer des outils d'évaluation des besoins psychosociaux",
        "Produire des rapports d'évaluation"
      ]
    },
    {
      id: 5,
      period: "Juillet 2022 - Septembre 2022",
      title: "Psychologue",
      company: "INTERSOS / UNHCR",
      location: "Plateau Central, Burkina Faso",
      tagline: "Prise en charge psychologique des cas de protection.",
      tasks: [
        "Prise en charge psychologique et psychosociale des cas de protection",
        "Évaluations cliniques et identification du traitement",
        "Élaboration de plans d'assistance individuelle",
        "Formations internes sur les PSP et l'accompagnement psychosocial"
      ]
    },
    {
      id: 6,
      period: "Décembre 2021 - Juin 2022",
      title: "Psychologue",
      company: "ACD/NAANGUE - UNICEF",
      location: "Sebba, Solhan, Burkina Faso",
      tagline: "Réponse multisectorielle communautaire pour la protection de l'enfance.",
      tasks: [
        "Évaluation des besoins en santé mentale et élaboration de plans de traitement",
        "Séances de psychothérapie individuelle, familiale et de groupe",
        "Formation du personnel et des communautés aux premiers secours psychosociaux"
      ]
    },
    {
      id: 7,
      period: "Septembre 2021 - Février 2022",
      title: "Chargé de Soutien Psychosocial",
      company: "ECLUD - OIM",
      location: "Yagha, Sebba, Burkina Faso",
      tagline: "Projet Santé Mentale et Soutien Psychosocial dans la province du Yagha.",
      tasks: [
        "Développement du dispositif de soutien psychosocial et de protection",
        "Formation du personnel et des communautés aux PSP",
        "Entretiens cliniques de soutien psychologique individuel et de groupe",
        "Appui aux activités de lutte contre les violences basées sur le genre"
      ]
    },
    {
      id: 8,
      period: "Octobre 2020 - Juin 2021",
      title: "Professeur vacataire en philosophie",
      company: "Lycée Provincial de Kombissiri",
      location: "Kombissiri, Burkina Faso",
      tagline: "Enseignement de la philosophie aux classes de terminale.",
      tasks: [
        "Préparation et dispensation des cours de philosophie",
        "Évaluation et suivi des élèves",
        "Préparation des élèves aux examens du baccalauréat"
      ]
    },
    {
      id: 9,
      period: "Juillet 2019 - Décembre 2019",
      title: "Chargé de communication",
      company: "Association FITIMA",
      location: "Ouagadougou, Burkina Faso",
      tagline: "Gestion de la communication et sensibilisation sur le handicap.",
      tasks: [
        "Élaboration de stratégies de communication",
        "Animation des réseaux sociaux et gestion du site web",
        "Organisation d'événements de sensibilisation sur le handicap"
      ]
    },
    {
      id: 10,
      period: "Février 2019 - Juillet 2019",
      title: "Psychologue Stagiaire",
      company: "Centre Médical avec Antenne Chirurgicale (CMA)",
      location: "Kombissiri, Burkina Faso",
      tagline: "Stage clinique en psychologie de la santé.",
      tasks: [
        "Consultations psychologiques et entretiens cliniques",
        "Accompagnement des patients hospitalisés",
        "Participation aux réunions de staff médical"
      ]
    },
    {
      id: 11,
      period: "Septembre 2018 - Octobre 2018",
      title: "Psychologue Stagiaire",
      company: "Centre Hospitalier Universitaire Yalgado Ouédraogo (CHU-YO)",
      location: "Ouagadougou, Burkina Faso",
      tagline: "Stage en psychiatrie et santé mentale.",
      tasks: [
        "Observation et participation aux consultations psychiatriques",
        "Entretiens cliniques sous supervision",
        "Participation aux activités de psychoéducation"
      ]
    }
  ],
  en: [
    {
      id: 1,
      period: "Since 2023",
      title: "Founder",
      company: "Dobo Mind and General Service",
      location: "Burkina Faso",
      tagline: "Company specialized in organizational development through mental health.",
      tasks: [
        "Founded and lead a company registered in the Burkina Faso commercial registry",
        "Business development using mental health as a strategic lever",
        "Consulting and supporting organizations on workplace well-being",
        "Designing mental health programs adapted to professional contexts"
      ]
    },
    {
      id: 2,
      period: "Since September 2025",
      title: "Parenting and Mental Health Coach",
      company: "MissPoppins",
      location: "USA, Canada",
      tagline: "Parenting coaching, personal development and leadership for families and executives.",
      tasks: [
        "Supporting parents in stress management, emotions and family dynamics",
        "Leadership development and decision-making support for executives and managers",
        "Promoting mental well-being and psychological health in daily life"
      ]
    },
    {
      id: 3,
      period: "August 2024 - August 2025",
      title: "Operations Consultant",
      company: "Sephora Canada",
      location: "Quebec, Canada",
      tagline: "Operational process optimization and team support in-store.",
      tasks: [
        "Analysis and improvement of processes (inventory, flow, resource planning)",
        "KPI monitoring and corrective action proposals",
        "Supporting managers in implementing internal policies",
        "Training and coaching teams in procedure application"
      ]
    },
    {
      id: 4,
      period: "September 2023 - June 2024",
      title: "Mental Health Officer - RRM Assessment Team",
      company: "International Rescue Committee (IRC)",
      location: "Ouahigouya, Burkina Faso",
      tagline: "Psychosocial support and needs assessment in conflict context.",
      tasks: [
        "Identifying alerts on shocks affecting populations",
        "Developing and maintaining relationships with field actors",
        "Analyzing collected data and making recommendations",
        "Creating psychosocial needs assessment tools",
        "Producing assessment reports"
      ]
    },
    {
      id: 5,
      period: "July 2022 - September 2022",
      title: "Psychologist",
      company: "INTERSOS / UNHCR",
      location: "Central Plateau, Burkina Faso",
      tagline: "Psychological care for protection cases.",
      tasks: [
        "Psychological and psychosocial care for protection cases",
        "Clinical assessments and treatment identification",
        "Development of individual assistance plans",
        "Internal training on PFA and psychosocial support"
      ]
    },
    {
      id: 6,
      period: "December 2021 - June 2022",
      title: "Psychologist",
      company: "ACD/NAANGUE - UNICEF",
      location: "Sebba, Solhan, Burkina Faso",
      tagline: "Community multi-sectoral response for child protection.",
      tasks: [
        "Mental health needs assessment and treatment plan development",
        "Individual, family and group psychotherapy sessions",
        "Training staff and communities in psychological first aid"
      ]
    },
    {
      id: 7,
      period: "September 2021 - February 2022",
      title: "Psychosocial Support Officer",
      company: "ECLUD - IOM",
      location: "Yagha, Sebba, Burkina Faso",
      tagline: "Mental Health and Psychosocial Support project in Yagha province.",
      tasks: [
        "Development of psychosocial support and protection system",
        "Training staff and communities in PFA",
        "Individual and group psychological support clinical interviews",
        "Support for activities against gender-based violence"
      ]
    },
    {
      id: 8,
      period: "October 2020 - June 2021",
      title: "Part-time Philosophy Teacher",
      company: "Kombissiri Provincial High School",
      location: "Kombissiri, Burkina Faso",
      tagline: "Teaching philosophy to senior year students.",
      tasks: [
        "Preparing and delivering philosophy courses",
        "Student assessment and monitoring",
        "Preparing students for baccalaureate exams"
      ]
    },
    {
      id: 9,
      period: "July 2019 - December 2019",
      title: "Communications Officer",
      company: "FITIMA Association",
      location: "Ouagadougou, Burkina Faso",
      tagline: "Communications management and disability awareness.",
      tasks: [
        "Developing communication strategies",
        "Social media management and website administration",
        "Organizing disability awareness events"
      ]
    },
    {
      id: 10,
      period: "February 2019 - July 2019",
      title: "Psychology Intern",
      company: "Medical Center with Surgical Unit (CMA)",
      location: "Kombissiri, Burkina Faso",
      tagline: "Clinical internship in health psychology.",
      tasks: [
        "Psychological consultations and clinical interviews",
        "Supporting hospitalized patients",
        "Participating in medical staff meetings"
      ]
    },
    {
      id: 11,
      period: "September 2018 - October 2018",
      title: "Psychology Intern",
      company: "Yalgado Ouédraogo University Hospital (CHU-YO)",
      location: "Ouagadougou, Burkina Faso",
      tagline: "Internship in psychiatry and mental health.",
      tasks: [
        "Observation and participation in psychiatric consultations",
        "Supervised clinical interviews",
        "Participation in psychoeducation activities"
      ]
    }
  ]
};

// Complete education data - Bilingual
export const educationData = {
  fr: [
    { id: 1, period: "Août 2025", degree: "DESS en Santé Mentale", institution: "Télé Université du Québec", status: "En cours" },
    { id: 2, period: "Juin 2025", degree: "Master Professionnel en Coopération Internationale et Aide Humanitaire", institution: "Kalu Institute, Madrid", status: "En cours" },
    { id: 3, period: "Mars 2022", degree: "Master 2 en Sciences de l'Éducation", institution: "IFRISSE", status: "Soutenance en attente" },
    { id: 4, period: "2019-2020", degree: "Master 1 en Sciences de l'Éducation", institution: "IFRISSE", status: "Diplôme obtenu (BAC+4)" },
    { id: 5, period: "2018-2019", degree: "Licence en Psychologie", institution: "Université Norbert Zongo de Koudougou", status: "Diplôme obtenu" },
    { id: 6, period: "2013-2014", degree: "Baccalauréat", institution: "Lycée Nelson Mandela", status: "Diplôme obtenu" }
  ],
  en: [
    { id: 1, period: "August 2025", degree: "Graduate Diploma in Mental Health", institution: "Télé Université du Québec", status: "In progress" },
    { id: 2, period: "June 2025", degree: "Professional Master in International Cooperation and Humanitarian Aid", institution: "Kalu Institute, Madrid", status: "In progress" },
    { id: 3, period: "March 2022", degree: "Master 2 in Education Sciences", institution: "IFRISSE", status: "Defense pending" },
    { id: 4, period: "2019-2020", degree: "Master 1 in Education Sciences", institution: "IFRISSE", status: "Degree obtained (BAC+4)" },
    { id: 5, period: "2018-2019", degree: "Bachelor's in Psychology", institution: "Norbert Zongo University of Koudougou", status: "Degree obtained" },
    { id: 6, period: "2013-2014", degree: "High School Diploma", institution: "Nelson Mandela High School", status: "Degree obtained" }
  ]
};

// Complete certifications data - Bilingual
export const certificationsData = {
  fr: [
    { id: 1, year: "2026", title: "Éducateur qualifié dans le domaine de la petite enfance", issuer: "Ministère de la Famille du Québec" },
    { id: 2, year: "2025", title: "Mental Health Leadership", issuer: "Harvard T.H. Chan School of Public Health", credentialId: "252Y-B2PK-WIEF" },
    { id: 3, year: "2025", title: "Certificat en secourisme général et RCR/DEA", issuer: "Croix Rouge Canadienne" },
    { id: 4, year: "2024", title: "Certificat Santé publique", issuer: "REMA" },
    { id: 5, year: "2023", title: "Clinique et psychopathologie des violences sexuelles", issuer: "ASADIS" },
    { id: 6, year: "2023", title: "Expertise Genre et inclusion en santé", issuer: "REMA" },
    { id: 7, year: "2023", title: "Programme COMPASS", issuer: "IRC / Harvard Business Publishing" },
    { id: 8, year: "2023", title: "Supervision du raisonnement clinique", issuer: "Université Montréal / EDULIB" }
  ],
  en: [
    { id: 1, year: "2026", title: "Qualified Early Childhood Educator", issuer: "Quebec Ministry of Family" },
    { id: 2, year: "2025", title: "Mental Health Leadership", issuer: "Harvard T.H. Chan School of Public Health", credentialId: "252Y-B2PK-WIEF" },
    { id: 3, year: "2025", title: "General First Aid and CPR/AED Certificate", issuer: "Canadian Red Cross" },
    { id: 4, year: "2024", title: "Public Health Certificate", issuer: "REMA" },
    { id: 5, year: "2023", title: "Clinical and Psychopathology of Sexual Violence", issuer: "ASADIS" },
    { id: 6, year: "2023", title: "Gender and Health Inclusion Expertise", issuer: "REMA" },
    { id: 7, year: "2023", title: "COMPASS Program", issuer: "IRC / Harvard Business Publishing" },
    { id: 8, year: "2023", title: "Clinical Reasoning Supervision", issuer: "University of Montreal / EDULIB" }
  ]
};

// Complete skills data - Bilingual
export const skillsData = {
  languages: [
    { name: "Français", nameEn: "French", level: "Lu, parlé et écrit", levelEn: "Read, spoken and written", percentage: 100 },
    { name: "Anglais", nameEn: "English", level: "Lu, parlé et écrit", levelEn: "Read, spoken and written", percentage: 85 },
    { name: "Moore", nameEn: "Moore", level: "Langue maternelle", levelEn: "Native language", percentage: 100 },
    { name: "Dioula", nameEn: "Dioula", level: "Seconde langue", levelEn: "Second language", percentage: 75 }
  ],
  technical: ["Word", "Excel", "PowerPoint", "SPSS", "Internet", "Outlook", "Ms Project", "WordPress", "Dr Java"]
};

// Projects data - Bilingual
export const projectsData = {
  fr: [
    { id: 1, title: "Formation en ligne - PSP & gestion du stress", description: "Conception d'un parcours de formation en ligne accessible aux professionnels et au grand public. Focus sur la gestion du stress, les PSP et la résilience.", url: "https://mhpsslearning.org", year: "2026" },
    { id: 2, title: "Abena AI - Chatbot santé mentale", description: "Conception d'un chatbot d'accompagnement en santé mentale. Orientation, psychoéducation et soutien de première ligne.", url: "https://abena-ai.com", year: "2025" },
    { id: 3, title: "Application Gestion du Stress (Brief COPE)", description: "Application centrée sur les mécanismes d'adaptation au stress. Outil d'auto-évaluation et de suivi des stratégies de coping.", url: "https://gestiondestress.com", year: "2025" }
  ],
  en: [
    { id: 1, title: "Online Training - PFA & Stress Management", description: "Design of an online training course accessible to professionals and the general public. Focus on stress management, PFA and resilience.", url: "https://mhpsslearning.org", year: "2026" },
    { id: 2, title: "Abena AI - Mental Health Chatbot", description: "Design of a mental health support chatbot. Guidance, psychoeducation and front-line support.", url: "https://abena-ai.com", year: "2025" },
    { id: 3, title: "Stress Management App (Brief COPE)", description: "Application focused on stress coping mechanisms. Self-assessment and coping strategy tracking tool.", url: "https://gestiondestress.com", year: "2025" }
  ]
};

// Engagements - Bilingual
export const engagementsData = {
  fr: [
    { id: 1, title: "Membre certifié de l'American Psychological Association" },
    { id: 2, title: "Membre de l'Association Canadienne pour la Santé Mentale" },
    { id: 3, title: "Annotateur d'Intelligence Artificielle", description: "Scale Labs / Outlier, projet Aether" }
  ],
  en: [
    { id: 1, title: "Certified member of the American Psychological Association" },
    { id: 2, title: "Member of the Canadian Mental Health Association" },
    { id: 3, title: "AI Annotator", description: "Scale Labs / Outlier, Aether project" }
  ]
};

export const navItems = [
  { id: "apropos", label: { fr: "À propos", en: "About" }, icon: "🔑" },
  { id: "competences", label: { fr: "Compétences", en: "Skills" }, icon: "🧠" },
  { id: "experiences", label: { fr: "Expériences", en: "Experience" }, icon: "📂" },
  { id: "formations", label: { fr: "Formations", en: "Education" }, icon: "🎓" },
  { id: "resultats", label: { fr: "Résultats", en: "Results" }, icon: "📊" },
  { id: "projets", label: { fr: "Projets", en: "Projects" }, icon: "💡" },
  { id: "contact", label: { fr: "Contact", en: "Contact" }, icon: "📬" }
];
